<script>
  import { createEventDispatcher } from 'svelte'
  import { makeSelectedElementFocusable } from '../utils.js'

  import { settingsResponse } from '../stores'

  const tabBorderColor =
    $settingsResponse.data.widget_settings.general_settings.primary_color

  const dispatch = createEventDispatcher()

  export let items
  export let activeTab
  export let hasFilters = true
  export let textColor

  let tabElements

  const ARROW_LEFT = 37
  const ARROW_RIGHT = 39

  const visibleTabs = items && items.filter(item => item.show)
  let currentTabIndex = visibleTabs.findIndex(item => item.label === activeTab)

  const changeToPreviousTab = () =>
    (currentTabIndex =
      currentTabIndex === 0 ? visibleTabs.length - 1 : currentTabIndex - 1)

  const changeToNextTab = () =>
    (currentTabIndex =
      currentTabIndex === visibleTabs.length - 1 ? 0 : currentTabIndex + 1)

  const handleChangeActiveTab = item => dispatch('tabChanged', item)

  const handleChangeActiveTabWithArrowkeys = e => {
    const nodeList = tabElements && tabElements.children
    e.preventDefault()
    if (e.keyCode === ARROW_LEFT) {
      const tabIndex = changeToPreviousTab()
      const item = visibleTabs[tabIndex]
      handleChangeActiveTab(item)
      makeSelectedElementFocusable(nodeList, tabIndex)
    }
    if (e.keyCode === ARROW_RIGHT) {
      const tabIndex = changeToNextTab()
      const item = visibleTabs[tabIndex]
      handleChangeActiveTab(item)
      makeSelectedElementFocusable(nodeList, tabIndex)
    }
  }
</script>

<style>
  .tab__wrapper {
    border-bottom: 0.4px solid #e8ebed;
    display: flex;
    align-items: center;
  }

  .tab__wrapper span {
    font-size: 14px;
    cursor: pointer;
    float: left;
    padding: 11px 18px;
    font-weight: 400;
    user-select: none;
    -webkit-user-select: none;
  }
</style>

<!-- <svelte:window /> -->
<div class="$style.tab__wrapper">
  <div
    bind:this={tabElements}
    role="tablist"
    aria-label="product reviews and QnA tabs"
    class="$style.tabs-button"
    style="color: {textColor};">
    {#each items as item, index (index)}
      {#if item.show}
        <span
          role="tab"
          aria-label={item.label}
          aria-controls={activeTab === item.label ? 'kb-productreviews-tabpanel' : 'kb-questions-and-answers-tabpanel'}
          tabindex={item.label === activeTab ? 0 : -1}
          aria-selected={item.label === activeTab}
          style={item.label === activeTab ? `border-bottom: 2px solid ${tabBorderColor}` : ''}
          on:click={() => handleChangeActiveTab(item)}
          on:keyup={e => handleChangeActiveTabWithArrowkeys(e, index)}>
          {item.label}
          {#if item.count > 0}({item.count}){/if}
        </span>
      {/if}
    {/each}
  </div>
  {#if hasFilters}
    <slot />
  {/if}
</div>
